import { useEffect, useState } from "react";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

export const useDeviceServiceData = (values, form) => {
  const [options, setOptions] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [lastServices, setLastServices] = useState([]);
  const [serviceBaseSelect, setServiceBaseSelect] = useState([]);
  const [dayView, setDayView] = useState(null); // <- dodaj stan dla day view
  const getDevices = async (searchTerm) => {
    const response = await GlobalAuthFetch({
      path: `/device/findBySN/${searchTerm.toUpperCase()}`,
    });

    const devices =
      response?.payload?.data?.map((p) => ({
        ...p,
        uuid: p.uuid,
        value: p.serialNumber,
      })) || [];

    setOptions(devices);
  };

  const fetchLastServices = async (serialNumber) => {
    if (!serialNumber) {
      setLastServices([]);
      return;
    }

    const response = await GlobalAuthFetch({
      path: `/service/${serialNumber}/last`,
    });

    setLastServices(response?.payload?.data || []);
  };

  useEffect(() => {
    const device = values?.device;
    if (!device) return;

    // --- selectedDevice ---
    setSelectedDevice((prev) => (prev?.uuid === device.uuid ? prev : device));

    // --- serviceBase ---
    if (!device.serviceBase) return;

    const nextServiceBase = {
      ...device.serviceBase,
      name: device.serviceBase.entryName,
      value: device.serviceBase.uuid,
    };

    const currentServiceBase = values?.serviceBase;

    if (
      currentServiceBase?.uuid === nextServiceBase.uuid &&
      currentServiceBase?.value === nextServiceBase.value
    ) {
      return;
    }

    form.change("serviceBase", nextServiceBase);
  }, [values?.device, values?.serviceBase, form]);

  useEffect(() => {
    const fetchDictionaries = async () => {
      const response = await GlobalAuthFetch({
        path: "/dictionary/serviceBase/fieldName",
      });

      setServiceBaseSelect(
        response?.payload?.data?.dictionaryEntries
          ?.sort((a, b) => a.entryName.localeCompare(b.entryName))
          ?.map((el) => ({
            name: el.entryName,
            value: el.uuid,
          })) || [],
      );
    };

    fetchDictionaries();
  }, []);

  const fetchServiceDayView = async (dateString) => {
    try {
      const response = await GlobalAuthFetch({
        path: `/service/day-view?date=${dateString}`, // np. "2026-02-23"
      });

      setDayView(response?.payload?.data || null);
    } catch (err) {
      console.error("Error fetching service day view:", err);
    }
  };

  return {
    options,
    selectedDevice,
    setSelectedDevice,
    lastServices,
    serviceBaseSelect,
    getDevices,
    fetchLastServices,
    dayView,
    fetchServiceDayView,
  };
};
